import { t } from "@/lib/i18n";
import type { Lang } from "@/lib/i18n";
import type { ClockState } from "@/hooks/useClock";
import type { Phase } from "@/data/phases";
import { profile } from "@/data/profile";
import { Avatar } from "./Avatar";
import { AnalogClock } from "./AnalogClock";
import { Celestial } from "./Celestial";

/** Persistent left column: identity + live clock. */
export function Identity({ lang, clock, phase }: { lang: Lang; clock: ClockState; phase: Phase }) {
  const { identity, brand } = profile;

  return (
    <aside className="flex flex-none flex-col items-center text-center md:w-[286px]">
      {/* celestial body sits behind the photo (the avatar is "in front of the moon") */}
      <div style={{ position: "relative", display: "flex", justifyContent: "center" }}>
        <Celestial kind={phase.celestial} tone={phase.celestialTone} />
        <div className="relative z-10 mb-8">
          <Avatar src={identity.avatar} initials={brand.initials} />
        </div>
      </div>

      <div
        style={{
          fontFamily: "var(--tc-mono)",
          fontSize: 11,
          letterSpacing: "0.3em",
          textTransform: "uppercase",
          color: "var(--tc-brass)",
          margin: "16px 0 0",
          textShadow: "0 1px 12px var(--tc-bg-1), 0 0 6px var(--tc-bg-1)",
        }}
      >
        {t(identity.role, lang)}
      </div>

      <AnalogClock clock={clock} />

      <div
        style={{
          marginTop: 20,
          fontFamily: "var(--tc-mono)",
          fontSize: 23,
          letterSpacing: "0.06em",
          color: "var(--tc-ink-strong)",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {clock.digital}
      </div>

      <div
        style={{
          marginTop: 6,
          display: "flex",
          alignItems: "center",
          gap: 8,
          fontFamily: "var(--tc-mono)",
          fontSize: 10,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          color: "var(--tc-faint)",
        }}
      >
        <span style={{ width: 5, height: 5, background: "var(--tc-brass)", transform: "rotate(45deg)" }} />
        {t(identity.clockLabel, lang)}
      </div>

      <p style={{ marginTop: 16, fontStyle: "italic", fontSize: 15, lineHeight: 1.5, color: "var(--tc-soft)" }}>
        {t(identity.tagline, lang)}
      </p>
    </aside>
  );
}
